// extracted by mini-css-extract-plugin
export default {"lamina":"Lamina01Portada_lamina__JFTMY","bg":"Lamina01Portada_bg__CEZ6B","logo":"Lamina01Portada_logo__RWdmX"};